import { useState, useEffect, useMemo, useCallback } from "react";
import { Col, Row, Container, Button } from "react-bootstrap";
import ModalVideo from "react-modal-video";
import CustomerStoriesCard from "./CustomerStoriesCard";
import Slider from "react-slick";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Url from "components/Url";

const NextArrow = ({ onClick }) => (
  <Button className="arrow next" onClick={onClick}>
    <IoIosArrowForward style={{ color: "whitesmoke" }} />
  </Button>
);

const PrevArrow = ({ onClick }) => (
  <Button className="arrow prev" onClick={onClick}>
    <IoIosArrowBack style={{ color: "whitesmoke" }} />
  </Button>
);

const CustomerStories = () => {
  const [isOpen, setOpen] = useState(false);
  const [videoID, setVideoID] = useState("");
  const urlData = Url();
  const s3URL = urlData["s3"];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 520);

  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth <= 520);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  const testimonials = useMemo(
    () => [
      {
        name: "Saurabh Panday",
        designation: "Web Development Intern",
        category: "Web Development",
        img: `${s3URL}testimonials/Saurabh_Panday.jpg`,
        videoId: "U1qbKZtT68I",
        description:
          "One of the best parts of my internship was the supportive team environment. Everyone was welcoming and willing to help me grow. By the end of my internship, I felt confident in my skills and proud of what I had accomplished.",
      },
      {
        name: "Sandesh Kayat",
        designation: "DevOps Intern",
        category: "DevOps",
        img: `${s3URL}testimonials/Sandesh_Kayat.jpg`,
        videoId: "eFr5DpNBDi8",
        description:
          "Throughout my internship, I gained valuable insights into DevOps. Managing infrastructure and streamlining deployment processes challenged me, but the support of my team helped me overcome every obstacle.",
      },
      {
        name: "Shashank Shekhar",
        designation: "Web Development Intern",
        category: "Web Development",
        img: `${s3URL}testimonials/Shashank_Shekhar.jpg`,
        videoId: "sVZEthKXZyU",
        description:
          "My internship experience was incredible! I worked on exciting projects and learned so much about web development. The supportive team environment made my journey even better.",
      },
      {
        name: "Ashish Kumar",
        designation: "Web Development Intern",
        category: "Web Development",
        img: `${s3URL}testimonials/Ashish_Kumar.jpg`,
        videoId: "eAIegasr0LY",
        description:
          "InternshipGate provided structured real-world projects that boosted my confidence and prepared me for job opportunities. Highly recommended for career enhancement.",
      },
      {
        name: "Rishabh",
        designation: "Data Science Intern",
        category: "Data Science",
        img: `${s3URL}testimonials/Rishabh.jpg`,
        videoId: "FpOEzOQvRAE",
        description:
          "The data science internship at InternshipGate was a great learning experience. The real projects gave me hands-on knowledge and boosted my confidence to step into the industry.",
      },
      {
        name: "Aditya Choudhary",
        designation: "IoT Intern",
        category: "IoT",
        img: `${s3URL}testimonials/Student_test1.jpg`,
        videoId: "6Dw7lFf5Tbc",
        description:
          "InternshipGate helped me find my passion and step out of my comfort zone. The experience was invaluable for my career growth.",
      },
    ],
    [s3URL]
  );

  const handleVideo = (id) => {
    setVideoID(id);
    setOpen(true);
  };

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed:2000,
    speed:1000,
    slidesToShow: isMobile ? 1 : 2,
    slidesToScroll: 1,
    centerPadding: isMobile ? "0px" : "100px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    fade: true,
    pauseOnHover: false,   // Ensures autoplay does not pause on hover
    pauseOnFocus: false,   // Ensures autoplay does not pause on focus
  };

  return (
    <section className="py-lg-6 bg-white py-6">
      <Container>
        <Row>
          <Col>
            <Row className="text-center">
              <Col md={12} className="px-md-16 mb-4 mt-2">
                <span className="text-uppercase text-primary fw-semi-bold ls-md" style={{fontSize:"20px",fontWeight:"bold"}}>
                  Student Stories
                </span>
                <h2 className="h1 fw-bold mt-3 mb-2" style={{fontWeight:"bold"}}>
                  What Our Students Say
                </h2>
                <p className="mb-0 fs-4" style={{fontWeight:"bold"}}>
                  Hear from students who have transformed their skills and
                  careers through our internship programs.
                </p>
              </Col>
            </Row>
            <div className="align-items-center d-flex flex-column flex-lg-row">
              <Slider {...settings}>
                {testimonials.map((item, index) => (
                  <CustomerStoriesCard
                    key={index}
                    handleVideo={handleVideo}
                    item={item}
                  />
                ))}
              </Slider>

              <ModalVideo
                channel="youtube"
                isOpen={isOpen}
                videoId={videoID}
                onClose={() => setOpen(false)}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CustomerStories;